namespace Roodik.Game{
	import ViewBase = Roodik.Core.ViewBase;
	import Tween = Roodik.Core.Tween.Tween;
	import Easing = Roodik.Core.Tween.Easing;
	import TimeUtility = Roodik.Core.TimeUtility;
	import ISoundManager = Roodik.Core.ISoundManager;

	export class TimerView extends ViewBase
	{
		private _message : PIXI.Text;

		constructor(private _soundManager:ISoundManager, private _timeReadyCallBack:()=>void)
		{
			super("TimerView");

			this.scale.x = 1.2;
			this.scale.y = 1.2;

			this._message = new PIXI.Text("0:00",
			{
				fontFamily: 'WellWait',
				fontSize: 45,
				fontStyle: 'italic',
				fontWeight: 'bold',
				fill: "#FFDEAD",
				stroke: '#000000',
				strokeThickness: 2,
				align:"center",
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 1,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			});
			this._message.x = -this._message.width*0.5 + 15;
			this._message.y = -this._message.height*0.5 - 4;
			this.addChild(this._message);

			/*this._timer = new Timer(()=>{
				this.TOTAL_TIME --;
				this._message.text = TimeUtility.visualize(this.TOTAL_TIME);
				if (this.TOTAL_TIME <= 0)
				{
					this._timesUpCallBack();
					this._timer.stop();
				}
				else if (this.TOTAL_TIME % 30 === 0)
				{
					let clock = this.childByName("clock").display;
					let rot = {scale:0.8}
					new Tween(rot)
					.to({scale:1.1}, 200)
					.easing(Easing.Quadratic.In)
					.onUpdate(()=>
					{
						clock.scale.x = rot.scale;
						clock.scale.y = rot.scale;
					})
					.onComplete(()=>{
						new Tween(rot)
						.to({scale:0.8}, 200)
						.easing(Easing.Quadratic.In)
						.onUpdate(()=>
						{
							clock.scale.x = rot.scale;
							clock.scale.y = rot.scale;
						})
						.start();
					})
					.start();
				}
			});
			this._timer.stop();*/
		}

		public show(timesLeft:number)
		{
			this._soundManager.playSound("Timer2.mp3", 0.6);
			let time = {time:0}
			new Tween(time)
			.to({time:timesLeft}, 1500)
			.easing(Easing.Quadratic.In)
			.onUpdate(()=>
			{
				this.updateTime(time.time);
			})
			.onComplete(()=>
			{
				let properties = {scale:this.scale.x, y:this.y};
				new Tween(properties)
				.to({scale: 1, y: -430}, 300)
				.easing(Easing.Quadratic.In)
				.onUpdate(()=>{
					this.scale.x = properties.scale;
					this.scale.y = properties.scale;
					this.y = properties.y;
				})
				.onComplete(()=>{

					this._timeReadyCallBack();
					// this._timer.start();
				})
				.start();
			})
			.start();
		}

		public updateTime(timesLeft:number)
		{
			this._message.text = TimeUtility.visualize(timesLeft);
		}

		public destroy()
		{
			this._timeReadyCallBack = null;

			this.removeChild(this._message);
			this._message.destroy();

			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/TimerView.ts